import React, { useState } from 'react';
import NavBar2 from './Navbar2/NavBar2'; 
import CartComponent from './CartComponent';

const Panier = () => {
  const [isCartVisible, setIsCartVisible] = useState(false);
  const toggleCart = () => {
    setIsCartVisible(!isCartVisible);
  };

  return (
    <div>
      <NavBar2/>
      <CartComponent/>
    </div>
  );
};

export default Panier;
